"use client";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import * as images from "@/components/images/Images";
import { Typography } from "@/components/ui/typography";
import { ROUTES } from "@/constants";

type HomeProps = {
  content: {
    heroTitle?: string;
    heroDescriptions?: string;
  };
};

export default function HeroBlockLanguage({ content }: HomeProps) {
  return (
    <section className="overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[9fr_11fr] lg:gap-[22px] lg:py-20">
          <div className="flex flex-col justify-center gap-8 lg:max-w-[540px]">
            <div className="grid grid-cols-1 gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>Professional translations in 100+ languages</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>
                  Access an elite network of translators with a wide variety of
                  specialized industry, use cases, and deliverable expertise
                  across any language pairing.
                </p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:w-[247px] h-[48px]"
              >
                <Link href={ROUTES.startOrder} className="!text-base w-full">
                  Start order
                </Link>
              </Button>
            </div>
          </div>
          <div className="flex">
            <Image
              alt="Languex Illustration"
              src={images.languagesHero}
              width={1204}
              height={1032}
              className=""
            />
          </div>
          {/* <div className="flex justify-end px-8">
            <div
              className="min-h-[475px] w-[354px] relative
                     flex"
            >
              <div
                className="absolute top-0 left-[12%] bg-[#E6E9F1] h-[505px] w-[354px]
                         rounded-3xl"
              ></div>

              <div className="flex absolute left-[35%] top-[15%]">
                <Image
                  alt="logoHeaderLanguage"
                  src={images.logoHeaderLanguage}
                  width={0}
                  height={0}
                  className="w-full h-full"
                  priority
                />
              </div>

              <div className="flex absolute items-center right-[-4%] bottom-[-2%]  ">
                <div className="flex items-center">
                  <Image
                    src={images.imageHeaderLanguage}
                    alt="imageHeaderLanguage"
                    width={0}
                    height={0}
                  />
                </div>
              </div>
              <div className="flex absolute items-center right-0 top-[45.5%]  ">
                <div
                  className="flex items-center bg-white w-[238px]  justify-center  h-[40px] rounded-2xl
                          shadow-[0_6px_11.6px_rgba(0,0,0,0.16)]"
                >
                  <div className="font-medium flex items-center text-[17px] justify-center gap-3">
                    <Image
                      alt="arabicon"
                      src={images.arabicon}
                      width={0}
                      height={0}
                      className="w-4.5"
                      priority
                    />
                    Arabic
                    <Image
                      alt="ArrowLanguageHeader"
                      src={images.ArrowLanguageHeader}
                      width={0}
                      height={0}
                      className="w-4"
                      priority
                    />
                    <Image
                      alt="spicon"
                      src={images.spicon}
                      width={0}
                      height={0}
                      className="w-4.5"
                      priority
                    />
                    Spanish
                  </div>
                </div>
              </div>
              <div
                className="flex absolute bg-white border-1 border-[#A5BBD9]
                                     rounded-[12px] items-center gap-2 px-4 py-1.5 font-medium left-[105%]
                                    top-[25%] text-[17px]"
              >
                French
              </div>
              <div
                className="flex absolute bg-white border-1 border-[#A5BBD9]
                                     rounded-[12px] items-center gap-2 px-4 py-1.5 font-medium left-[105%]
                                     top-[35%] text-[17px]"
              >
                Brazil
              </div>
              <div
                className="flex absolute bg-white border-1 border-[#A5BBD9]
                                     rounded-[12px] items-center gap-2 px-4 py-1.5 font-medium left-[105%]
                                     top-[45%] text-[17px]"
              >
                Indonesia
              </div>
              <div
                className="flex absolute bg-white border-1 border-[#A5BBD9]
                                     rounded-[12px] items-center gap-2 px-4 py-1.5 font-medium left-[105%]
                                     top-[55%] text-[17px]"
              >
                Japan
              </div>

              <div
                className="flex absolute  flex-col shadow-[0_6px_11.6px_rgba(0,0,0,0.16)]
                                     items-center left-0
                                    top-[10%] bg-white px-4 py-3.5 gap-4 w-[125px] rounded-2xl"
              >
                <Image
                  src={images.alexAvatar}
                  alt="AlexAvatar"
                  width={0}
                  height={0}
                  className="w-18"
                />
                <div className="flex w-full justify-center">
                  <span className="font-[500]">Alex Reyhan</span>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
